import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { QuickActionType } from "../types";
import { useBrandQuickActions } from "./useBrandQuickActions";
import { useRetailerQuickActions } from "./useRetailerQuickActions";
export var useModalContent = function useModalContent() {
  var _quickActions$QuickAc, _quickActions$QuickAc2, _quickActions$QuickAc3, _quickActions$QuickAc4, _quickActions$QuickAc5, _quickActions$QuickAc6, _quickActions$QuickAc7, _quickActions$QuickAc8;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var retailerQuickActions = useRetailerQuickActions();
  var brandQuickActions = useBrandQuickActions();
  var quickActions = _objectSpread(_objectSpread({}, retailerQuickActions), brandQuickActions);
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, QuickActionType.ACCEPT_AN_ORDER, {
    title: (_quickActions$QuickAc = quickActions[QuickActionType.ACCEPT_AN_ORDER]) === null || _quickActions$QuickAc === void 0 ? void 0 : _quickActions$QuickAc.label,
    description: strictLocalize({
      id: "ou6wIg",
      defaultMessage: [{
        "type": 0,
        "value": "Nehmen Sie neue Bestellungen an, indem Sie die geschätzte Lieferzeit angeben"
      }]
    }),
    buttonText: strictLocalize({
      id: "5e09EO",
      defaultMessage: [{
        "type": 0,
        "value": "Geschätzte Lieferzeit angeben"
      }]
    })
  }), QuickActionType.REQUEST_COMMISSION_CHANGE, {
    title: (_quickActions$QuickAc2 = quickActions[QuickActionType.REQUEST_COMMISSION_CHANGE]) === null || _quickActions$QuickAc2 === void 0 ? void 0 : _quickActions$QuickAc2.label,
    description: strictLocalize({
      id: "rAF6ME",
      defaultMessage: [{
        "type": 0,
        "value": "Fordern Sie eine Aktualisierung der Faire-Direct-Provision bei Bestellungen für Einzelhändler an, mit denen Sie eine bestehende Großhandelsbeziehung haben."
      }]
    }),
    buttonText: strictLocalize({
      id: "cX24dx",
      defaultMessage: [{
        "type": 0,
        "value": "Anfrage zur Aktualisierung der Provision starten"
      }]
    })
  }), QuickActionType.EDIT_ITEM_AVAILABILITY, {
    title: (_quickActions$QuickAc3 = quickActions[QuickActionType.EDIT_ITEM_AVAILABILITY]) === null || _quickActions$QuickAc3 === void 0 ? void 0 : _quickActions$QuickAc3.label,
    description: strictLocalize({
      id: "b1DBx0",
      defaultMessage: [{
        "type": 0,
        "value": "Verfügbarkeit der Artikel in ausstehenden Bestellungen aktualisieren"
      }]
    }),
    buttonText: strictLocalize({
      id: "zkYVp5",
      defaultMessage: [{
        "type": 0,
        "value": "Artikelverfügbarkeit bearbeiten"
      }]
    })
  }), QuickActionType.CANCEL_AN_ORDER, {
    title: (_quickActions$QuickAc4 = quickActions[QuickActionType.CANCEL_AN_ORDER]) === null || _quickActions$QuickAc4 === void 0 ? void 0 : _quickActions$QuickAc4.label,
    description: strictLocalize({
      id: "uw/QeA",
      defaultMessage: [{
        "type": 0,
        "value": "Stornieren einer Bestellung, die noch nicht abgewickelt oder versandt wurde"
      }]
    }),
    buttonText: strictLocalize({
      id: "sPg2u4",
      defaultMessage: [{
        "type": 0,
        "value": "Stornierung starten"
      }]
    })
  }), QuickActionType.TRACK_AN_ORDER, {
    title: (_quickActions$QuickAc5 = quickActions[QuickActionType.TRACK_AN_ORDER]) === null || _quickActions$QuickAc5 === void 0 ? void 0 : _quickActions$QuickAc5.label,
    description: strictLocalize({
      id: "vvqBDw",
      defaultMessage: [{
        "type": 0,
        "value": "Details zur Sendungsverfolgung für bereits versandte Bestellungen anzeigen"
      }]
    }),
    buttonText: strictLocalize({
      id: "uVSNXI",
      defaultMessage: [{
        "type": 0,
        "value": "Bestellung verfolgen"
      }]
    })
  }), QuickActionType.RETURN_ITEMS, {
    title: (_quickActions$QuickAc6 = quickActions[QuickActionType.RETURN_ITEMS]) === null || _quickActions$QuickAc6 === void 0 ? void 0 : _quickActions$QuickAc6.label,
    description: strictLocalize({
      id: "SM+WKr",
      defaultMessage: [{
        "type": 0,
        "value": "Rückgabe von Artikeln aus Bestellungen, die innerhalb der letzten 60 Tage eingegangen sind. Nur Ihre erste Bestellung von einer bestimmten Marke kann zurückgegeben werden."
      }]
    }),
    buttonText: strictLocalize({
      id: "ylvEif",
      defaultMessage: [{
        "type": 0,
        "value": "Eine Rückgabe starten"
      }]
    })
  }), QuickActionType.CONTACT_A_BRAND, {
    title: (_quickActions$QuickAc7 = quickActions[QuickActionType.CONTACT_A_BRAND]) === null || _quickActions$QuickAc7 === void 0 ? void 0 : _quickActions$QuickAc7.label,
    description: strictLocalize({
      id: "Tce2uo",
      defaultMessage: [{
        "type": 0,
        "value": "Wenden Sie sich bei spezifischen Fragen zum Produkt oder bei Anliegen bezüglich des Zeitpunkts einer Bestellung an die jeweilige Marke. Dies ist der schnellste und beste Weg, um offene Fragen zu klären."
      }]
    }),
    buttonText: strictLocalize({
      id: "jHHKwS",
      defaultMessage: [{
        "type": 0,
        "value": "Marke kontaktieren"
      }]
    })
  }), QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS, {
    title: (_quickActions$QuickAc8 = quickActions[QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS]) === null || _quickActions$QuickAc8 === void 0 ? void 0 : _quickActions$QuickAc8.label,
    description: strictLocalize({
      id: "95bnr6",
      defaultMessage: [{
        "type": 0,
        "value": "Melden Sie Probleme mit Ihrer Bestellung innerhalb von 14 Tagen nach der Lieferung"
      }]
    }),
    buttonText: strictLocalize({
      id: "EfYP7O",
      defaultMessage: [{
        "type": 0,
        "value": "Meldung von beschädigten/fehlenden Artikeln starten"
      }]
    })
  });
};